<div
  class="card card-custom"
  [ngClass]="{
    'card-body-progress': viewLoading,
    'card-body-progress card-body-progress-overlay': loadingAfterSubmit
  }"
>
  <div class="card-header" *ngIf="role">
    <div class="card-title">
      <h3 class="card-label" translate>
        {{ getTitle() }}
        <span class="card-label">{{ roleTitle ? roleTitle : '' }} Role</span>
      </h3>
    </div>
  </div>
  <div class="form">
    <div class="card-body" *ngIf="role">
      <!-- <div class="card-body-progress">
                    <mat-spinner [diameter]="20"></mat-spinner>
                </div> -->
      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <span translate="GLOBAL.FORM_ERROR"></span>
      </kt-alert>

      <!--<kt-alert *ngIf="hasSubmissionErrors && !hasFormErrors" type="warn" [duration]="30000" [showCloseButton]="true" (closeAl)="onAlertClose($event)">
                <ul>
                    <li *ngFor="let msg of submissionErrorObj">{{msg.message | translate}}</li>
                </ul>
			</kt-alert>-->

      <div class="mb-2">
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label translate="ROLES.FORM.TITLE">Title</mat-label>
          <input matInput [(ngModel)]="role.title" [errorStateMatcher]="titleMatcher" required />
          <mat-error>
            <span translate="ROLES.FORM.TITLE_REQUIRED">Title is required</span>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="mb-2" *ngIf="isSuperAdmin && role.id === 0">
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label translate="ROLES.FORM.COMPANY">Company</mat-label>
          <mat-select
            [disabled]="role.id !== 0"
            [(ngModel)]="role.companyID"
            [errorStateMatcher]="companyMatcher"
            required
          >
            <mat-option [value]="0">---</mat-option>
            <mat-option *ngFor="let company of companiesList" [value]="company.id">
              {{ company.name }}
            </mat-option>
          </mat-select>
          <mat-error>
            <span translate="ROLES.FORM.COMPANY_REQUIRED">Company is required</span>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="mb-2" *ngIf="!isSuperAdmin">
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>Chat Department</mat-label>
          <mat-select [(ngModel)]="role.department_id">
            <mat-option *ngIf="departmentObj.id" [value]="departmentObj">
              {{ departmentObj.name }}
            </mat-option>
            <mat-option *ngFor="let department of departments" [value]="department">
              {{ department.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="separator separator-dashed my-6"></div>
      <div class="permissions-title-container">
        <h6><span translate="ROLES.FORM.PERMISSIONS">Permissions</span>:</h6>
        <div>
          <button
            type="button"
            mat-raised-button
            color="primary"
            (click)="onCopyPermissionClicked()"
            *ngIf="showCopyPermissions"
          >
            <span>Copy Permissions from Existing Role</span>
          </button>
        </div>

        <div>
          <button
            type="button"
            mat-raised-button
            color="primary"
            (click)="onCopyRoleTemplatePermissionClicked()"
            *ngIf="showCopyRoleTemplatePermissions"
          >
            <span>Copy Permissions from Role Template</span>
          </button>
        </div>
      </div>

      <div class="role-timeline-3 mb-5">
        <div class="role-timeline-3-items role-timeline-3-items-rolePermissions">
          <div *ngFor="let _rootRole of rolePermissions" class="role-timeline-3-inner">
            <div class="row role-timeline-3-item role-border-bottom-grey role-py-15 role-bg-grey">
              <span class="role-timeline-3-item-time">
                <mat-checkbox
                  [(ngModel)]="_rootRole.isSelected"
                  (change)="isSelectedChanged(_rootRole)"
                >
                  {{ _rootRole.title | translate }}</mat-checkbox
                >
              </span>
            </div>
            <div
              class="row d-flex align-items-center role-border-bottom-grey role-py-15 role-bg-grey"
              *ngIf="_rootRole._children.length > 0"
            >
              <div
                class="role-timeline-3-item role-timeline-3-item-child"
                *ngFor="let _childRole of getChildrenSorted(_rootRole._children)"
              >
                <span class="role-timeline-3-item-time">
                  <mat-checkbox
                    [(ngModel)]="_childRole.isSelected"
                    (change)="isSelectedChanged(_childRole)"
                  >
                    {{ _childRole.title | translate }}
                  </mat-checkbox>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            [mat-dialog-close]="data.animal"
            cdkFocusInitial
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            [disabled]="viewLoading"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
